var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"molecule-menu-trigger",class:{ active: _vm.isOpen },on:{"click":_vm.toggleSidebar}},[_c('AtomsCommonAtomIcon',{attrs:{"icon":"bars","size":32,"color":"#fff"}}),_vm._v(" "),_c('AtomsCommonAtomIcon',{attrs:{"icon":"xmark","size":32,"color":"#fff"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }